import { render, staticRenderFns } from "./NumberComponent.vue?vue&type=template&id=7616fed8&scoped=true"
import script from "./NumberComponent.vue?vue&type=script&lang=js"
export * from "./NumberComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7616fed8",
  null
  
)

export default component.exports